import React, { useEffect, useState } from "react";
import { getCompany, updateCompany } from "../../services/companyService";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import "../../admin/pages/styles/company.css";

function EditCompany() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    companyName: "",
    companyCode: "",
    hierarchicalLevel: "",
    relationType: ""
  });

  const [errors, setErrors] = useState({});
  const [showToast, setShowToast] = useState(false);

  const loadCompany = async () => {

    try {

      const res = await getCompany(id);

      setForm(res.data);

    } catch (error) {

      console.error(error);

    }

  };

  useEffect(() => {
    loadCompany();
  }, []);

  const handleChange = (e) => {

    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value
    });

    setErrors({
      ...errors,
      [name]: ""
    });

  };

  const validate = () => {

    let newErrors = {};

    if (!form.companyName.trim())
      newErrors.companyName = "Company Name required";

    if (!form.companyCode.trim())
      newErrors.companyCode = "Company Code required";

    if (!form.hierarchicalLevel)
      newErrors.hierarchicalLevel = "Level required";

    if (!form.relationType)
      newErrors.relationType = "Relation type required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!validate()) return;

    try {

      await updateCompany(id, form);

      setShowToast(true);

      setTimeout(() => {
        navigate("/admin/company");
      }, 2000);

    } catch (error) {

      console.error(error);

    }

  };

  return (
    <Layout>

      <div className="company-container">

        <h2>Edit Company</h2>

        <form className="company-form" onSubmit={handleSubmit}>

          <input
            name="companyName"
            placeholder="Company Name"
            value={form.companyName}
            onChange={handleChange}
          />

          {errors.companyName &&
            <p className="error-text">{errors.companyName}</p>}

          <input
            name="companyCode"
            placeholder="Company Code"
            value={form.companyCode}
            onChange={handleChange}
          />

          {errors.companyCode &&
            <p className="error-text">{errors.companyCode}</p>}

          {/* Level Dropdown */}

          <select
            name="hierarchicalLevel"
            value={form.hierarchicalLevel}
            onChange={handleChange}
          >
            <option value="">Select Level</option>

            {[...Array(10)].map((_, i) => (
              <option key={i+1} value={i+1}>
                Level {i+1}
              </option>
            ))}

          </select>

          {errors.hierarchicalLevel &&
            <p className="error-text">{errors.hierarchicalLevel}</p>}

          <select
            name="relationType"
            value={form.relationType}
            onChange={handleChange}
          >
            <option value="">Select Relation</option>
            <option value="R2">R2</option>
            <option value="R3">R3</option>
          </select>

          {errors.relationType &&
            <p className="error-text">{errors.relationType}</p>}

          <button type="submit">
            Update Company
          </button>

        </form>

        {/* Toast */}

        <div className="toast-container position-fixed top-0 end-0 p-3">

          <div className={`toast ${showToast ? "show" : ""}`}>

            <div className="toast-header bg-success text-white">

              <strong className="me-auto">Success</strong>

              <button
                type="button"
                className="btn-close"
                onClick={() => setShowToast(false)}
              ></button>

            </div>

            <div className="toast-body">
              Company updated successfully ✅
            </div>

          </div>

        </div>

      </div>

    </Layout>
  );
}

export default EditCompany;